import { getForegroundColor, createIconComponentFromSimpleIconsSvgPath } from '@consent-manager/core';
import { siVimeo } from 'simple-icons';

function vimeoIntegration() {
  var title = siVimeo.title,
    slug = siVimeo.slug,
    hex = siVimeo.hex,
    path = siVimeo.path;
  var color = "#" + hex;
  var contrastColor = getForegroundColor(color);
  var Icon = createIconComponentFromSimpleIconsSvgPath(title, path);
  return {
    id: slug,
    title: title,
    category: 'Videos',
    color: color,
    contrastColor: contrastColor,
    Icon: Icon,
    privacyPolicyUrl: "https://vimeo.com/privacy",
    description: 'Vimeo is a video sharing service trusted By Over 80 Million Worldwide.'
  };
}

export { vimeoIntegration };
//# sourceMappingURL=integration-vimeo.esm.js.map
